export function createSearchParams(params) {
    const searchParams = new URLSearchParams();
    for (const [name, value] of Object.entries(params)) {
        if (value != null) {
            searchParams.append(name, value.toString());
        }
    }
    return searchParams;
}
